module.exports = __webpack_public_path__ + "img/exostructure1.0037c6a2.png";